// Version utility to get app version from package.json
import packageJson from '../../package.json';

export const getAppVersion = () => {
  return packageJson.version;
};

export const getBuildInfo = () => {
  // Get build timestamp from environment variable set during build
  const buildTime = process.env.REACT_APP_BUILD_TIME || new Date().toISOString();
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER || 'dev';
  
  return {
    version: getAppVersion(),
    buildTime,
    buildNumber
  };
};
